import React, { useCallback } from 'react'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import getContentJumpUrl from 'lib/get-content-jump-url'
import CommonCard from 'Components/new/common-card'

interface IProps {
  order?: number
  className?: string
  title: string
  activeIndex?: number
  itemTeaParams?: any
  titleTeaParams?: any
  uniqueIdStr: string
  articleType?: number
  videoInfo: {
    coverUrl: string
    videoDuration: number
    videoWatchCount: number
    videoSize: string
  }
  column: {
    id?: number
    logo?: string
    name?: string
    introduction?: string
    description?: string
    episode?: number
    modify_time?: number
    publish_time: number
  }
  hasTop?: boolean
  onClickTitle?(): void
  onClickContent?(): void
  coverLazy?: boolean
  [key: string]: any
}

const Item: React.FC<IProps> = ({
  className,
  activeIndex,
  title,
  uniqueIdStr,
  articleType,
  videoInfo,
  column,
  itemTeaParams,
  titleTeaParams,
  order,
  hasTop = true,
  onClickTitle,
  onClickContent,
  coverLazy,
  ...props
}) => {
  const handleClick = useCallback(() => {
    if (itemTeaParams) {
      sendTeaCommEvent(
        'clk_event',
        Object.assign(itemTeaParams, {
          group_id: uniqueIdStr,
          rank: typeof activeIndex === 'number' ? `${activeIndex}` : '',
          item_rank: typeof order === 'number' ? `${order}` : '',
          section_id: `${column?.id}`,
          section_name: column?.name,
        })
      )
    }
    onClickContent && onClickContent()
  }, [uniqueIdStr, activeIndex, order, column?.id, column?.name])

  const handleTitleClick = useCallback(() => {
    if (titleTeaParams) {
      sendTeaCommEvent(
        'clk_event',
        Object.assign(titleTeaParams, {
          group_id: uniqueIdStr,
          rank: typeof activeIndex === 'number' ? `${activeIndex}` : '',
          item_rank: typeof order === 'number' ? `${order}` : '',
          section_id: `${column?.id}`,
          section_name: column?.name,
        })
      )
    }
    onClickTitle && onClickTitle()
  }, [uniqueIdStr, activeIndex, order, column?.id, column?.name])

  const jumpUrl = getContentJumpUrl(uniqueIdStr, articleType)

  return (
    <CommonCard
      type={'group'}
      className="tw-pb-24"
      collectVisible={false}
      id={uniqueIdStr}
      coverUrl={videoInfo?.coverUrl}
      articleType={articleType}
      title={title}
      watchCount={videoInfo?.videoWatchCount}
      duration={videoInfo?.videoDuration}
      publishTime={column?.publish_time}
      groupId={hasTop ? String(column.id) : undefined}
      groupName={column?.name}
      total={column?.episode}
      onClickGroup={handleTitleClick}
      onClick={handleClick}
      coverLazy={coverLazy}
    />
  )
}

export default Item
